const S = {};

S.modules = {

    /** @var {[]} Array of all available modules. */
    instances: [],

    /**
     * Initialize all modules. Optionally only modules for a given context.
     *
     * @param {string|HTMLElement|jQuery} [context]
     */
    init(context)
    {
        const startModules = [];

        if (typeof context === 'undefined')
        {
            context = document.body;
        }

        const $context = jQuery(context).find('*').add(context);

        $context.each(function ()
        {
            const $module = jQuery(this);

            jQuery.each(this.attributes, function (index, attribute)
            {
                if (!attribute || attribute.name.indexOf('data-js-') !== 0)
                {
                    return;
                }

                const name = S.modules.dashToCamelCase(attribute.name.slice(8));

                if ($module.data('module_' + name))
                {
                    // console.info('S.' + name + ' already initialized!');

                    // continue;
                    return true;
                }

                const data = {
                    name: name,
                    values: {},
                    elements: {},

                    /**
                     * Get a defined parameter with an optional default value.
                     *
                     * @param {string} key
                     * @param {*} [defaultValue]
                     * @returns {*}
                     */
                    get(key, defaultValue)
                    {
                        let result = defaultValue;

                        if (typeof this.values[key] !== 'undefined')
                        {
                            result = this.values[key];
                        }

                        return result;
                    },
                };

                data.values = S.modules.parseConfig(attribute.value, $module);
                data.elements = S.modules.findScriptElements($module);

                // init simple module
                if (typeof S[name] === 'function')
                {
                    // save instance as jQuery data
                    $module.data('has_module', true);
                    $module.data('module_' + name, S[name]);
                    $module.data('modules', ($module.data['modules'] || []).concat(S[name]));

                    S[name].call(S[name], $module, data);
                }

                // init complex module
                else if (typeof S[name] === 'object' && typeof S[name].init === 'function')
                {
                    let parentObject = S[name],
                        originalObject = parentObject;

                    // originalObject does not exist
                    // save originalObject and hook all functions
                    if (typeof originalObject['_originalObject'] === 'undefined')
                    {
                        S[name] = jQuery.extend(true, {}, S[name]);
                        S[name]['_originalObject'] = originalObject;

                        parentObject = S[name];

                        // hook all function calls
                        for (const key in parentObject)
                        {
                            if (!Object.prototype.hasOwnProperty.call(parentObject, key))
                            {
                                continue;
                            }

                            if (key === 'init' || key === 'start')
                            {
                                continue;
                            }

                            if (typeof parentObject[key] === 'function')
                            {
                                parentObject[key] = (function (key)
                                {
                                    return function ()
                                    {
                                        const args = arguments;

                                        jQuery.each(this['instances'], function (_, instance)
                                        {
                                            instance[key].apply(instance, args);
                                        });
                                    };
                                })(key);
                            }
                        }
                    }

                    // originalObject exists - reuse it
                    else
                    {
                        originalObject = originalObject['_originalObject'];
                    }

                    // keep reference to all instances
                    if (typeof parentObject['instances'] === 'undefined')
                    {
                        parentObject['instances'] = [];
                    }

                    const object = jQuery.extend(true, {}, originalObject);

                    object['name'] = name;
                    object['data'] = data;
                    object['$module'] = $module;
                    object['id'] = S.modules.instances.length;
                    object['instance'] = parentObject['instances'].length;
                    object['config'] = jQuery.extend(object['config'] || {}, data.values);
                    object['elements'] = jQuery.extend(object['elements'] || {}, data.elements);

                    // ensure jQuery object
                    jQuery.each(object['elements'], function (key, value)
                    {
                        if (!(value instanceof jQuery))
                        {
                            object['elements'][key] = jQuery();
                        }
                    });

                    parentObject['instances'].push(object);
                    object['instances'] = parentObject['instances'];

                    S.modules.instances.push(object);

                    // save instance as jQuery data
                    $module.data('has_module', true);
                    $module.data('module_' + name, object);
                    $module.data('modules', ($module.data('modules') || []).concat(object));

                    // initialize relations
                    S.modules.initRelations(object);

                    object.init(object['$module'], object['config'], object['elements'], object['data']);

                    // has start function
                    if (typeof object.start === 'function')
                    {
                        startModules.push(object);
                    }
                }

                else
                {
                    console.warn('S.' + name + ' could not be initialized.', $module);
                }
            });
        });

        // call start functions
        jQuery.each(startModules, function (_, module)
        {
            module.start(module['$module'], module['config'], module['elements'], module['data']);
        });
    },

    /**
     * Converts a dash-string to lowerCamelCase.
     *
     * @param {string} value
     * @return {string}
     */
    dashToCamelCase(value)
    {
        return value.toLowerCase().replace(/-(\w)/g, function (a, b)
        {
            return b.toUpperCase();
        });
    },

    /**
     * Returns all ".js-variable-name" descendants.
     *
     * @param {string|HTMLElement|jQuery} context
     * @returns {{}}
     */
    findScriptElements(context)
    {
        const
            result = {},
            $context = jQuery(context),
            modules = $context.find('[class*="mod-"], [class*="nav-"]').get();

        $context.find('[class*="js-"]').each(function (index, element)
        {
            for (const module of modules)
            {
                // it belongs to a sub-module
                if (jQuery.contains(module, element))
                {
                    // continue;
                    return true;
                }
            }

            const matches = element.className.match(/(?:^|\s)js-(\S+)/g);

            if (!matches)
            {
                // continue;
                return true;
            }

            for (const match of matches)
            {
                const name = '$' + S.modules.dashToCamelCase(match.replace(/^\s*js-/, ''));

                if (typeof result[name] === 'undefined' || !(result[name] instanceof jQuery))
                {
                    result[name] = jQuery(element);
                }
                else
                {
                    result[name] = result[name].add(element);
                }
            }
        });

        return result;
    },

    /**
     * Parses config attributes or JSON.
     *
     * @param {string} attributeValue
     * @param {jQuery} $module
     * @returns {{}}
     */
    parseConfig(attributeValue, $module)
    {
        let result = {};

        // looks like JSON
        if (attributeValue.substr(0, 1) === '{')
        {
            try
            {
                result = jQuery.parseJSON(attributeValue);
            }
            catch (e)
            {
                console.warn(e.message, attributeValue, $module);
            }
        }

        // key1: value1, key2: value2, ...
        else
        {
            // split by comma but accept escape sequence "\,"
            const pairs = attributeValue.match(/(\\.|[^,])+/g);

            if (!pairs)
            {
                return result;
            }

            jQuery.each(pairs, function (_, pair)
            {
                // split by colon but accept escape sequence "\:"
                pair = pair.match(/^\s*((?:\\.|[^:])+?)\s*(?::\s*(.+?))?\s*$/);

                // replace escape sequence
                const key = pair[1].replace('\\,', ',').replace('\\:', ':');

                let value = pair[2];

                if (value !== undefined)
                {
                    // replace escape sequence
                    value = value.replace('\\,', ',').replace('\\:', ':');
                }

                if (value === 'true')
                {
                    value = true;
                }
                else if (value === 'false')
                {
                    value = false;
                }
                else if (value === 'null')
                {
                    value = null;
                }
                else if (value === 'undefined')
                {
                    value = undefined;
                }
                else if (jQuery.isNumeric(value))
                {
                    value = Number(value);
                }

                result[key] = value;
            });
        }

        return result;
    },

    /**
     * Initialize all relations like parents, children and siblings
     *
     * @param {Object} module
     */
    initRelations(module)
    {
        /* eslint max-depth: off */

        /**
         * Parent modules of this module
         *
         * @type {Object[]}
         */
        module['parents'] = [];

        /**
         * Child modules of this module
         *
         * @type {Object[]}
         */
        module['children'] = [];

        /**
         * Sibling modules of this module
         *
         * @type {Object[]}
         */
        module['siblings'] = [];

        this.initRelationHelpers(module);

        let $parent = module.$module.parent();

        // walk through all parents until we find a module
        while ($parent.length)
        {
            // this parent has a module
            if ($parent.data('has_module'))
            {
                const parentModules = $parent.data('modules');

                // add all parents
                module['parents'] = parentModules;

                // walk through each parent and add children and siblings
                for (const parent of parentModules)
                {
                    parent['children'].push(module);

                    for (const child1 of parent['children'])
                    {
                        for (const child2 of parent['children'])
                        {
                            if (child1 === child2)
                            {
                                continue;
                            }

                            if (child1['siblings'].indexOf(child2) !== -1)
                            {
                                continue;
                            }

                            if (child1.$module.is(child2.$module))
                            {
                                continue;
                            }

                            child1['siblings'].push(child2);
                        }
                    }
                }

                break;
            }

            // otherwise try next parent
            $parent = $parent.parent();
        }
    },

    /**
     * Initialize relation helpers like parentOfType(), childrenOfType() and siblingsOfType()
     *
     * @param {Object} module
     */
    initRelationHelpers(module)
    {
        /**
         * Find the parent of specified type
         *
         * @param {string} type
         * @returns {null|Object}
         */
        module['parentOfType'] = (type) =>
        {
            for (const parent of module['parents'])
            {
                if (parent.name === type)
                {
                    return parent;
                }
            }

            return null;
        };

        /**
         * Finds all children of specified type
         *
         * @param {string} type
         * @returns {Object[]}
         */
        module['childrenOfType'] = (type) =>
        {
            const result = [];

            for (const child of module['children'])
            {
                if (child.name === type)
                {
                    result.push(child);
                }
            }

            return result;
        };

        /**
         * Finds all siblings of specified type
         *
         * @param {string} type
         * @returns {Object[]}
         */
        module['siblingsOfType'] = (type) =>
        {
            const result = [];

            for (const sibling of module['siblings'])
            {
                if (sibling.name === type)
                {
                    result.push(sibling);
                }
            }

            return result;
        };
    },
};

/**
 * Returns a module instance.
 *
 * @param {string} name
 * @returns {*}
 */
jQuery.fn['module'] = function (name)
{
    const instance = this.data('module_' + name);

    if (instance)
    {
        return instance;
    }
};

jQuery(document).ready(function ()
{
    S.modules.init();
});
